import { useInfiniteQuery } from '@tanstack/react-query';
import {
  fetchPotentialEventBusinessManagers, fetchPotentialPartnerBusinessManagers,
  fetchPotentialPlaceBusinessManagers,
} from '../endpoints/api';

export function useFetchPotentialPlaceBusinessManagers(placeId: number, term: string = '') {
  return useInfiniteQuery(
    ['potentialPlaceBusinessManagers', placeId, term],
    ({pageParam = 1}) => fetchPotentialPlaceBusinessManagers(placeId, term, pageParam),
    {
      enabled: !!placeId,
      getNextPageParam: (lastPage) => {
        const {current_page, last_page} = lastPage.data;
        return current_page < last_page ? current_page + 1 : undefined;
      },
    }
  );
}

export function useFetchPotentialEventBusinessManagers(eventId: number, term: string = '') {
  return useInfiniteQuery(
    ['potentialEventBusinessManagers', eventId, term],
    ({pageParam = 1}) => fetchPotentialEventBusinessManagers(eventId, term, pageParam),
    {
      enabled: !!eventId,
      getNextPageParam: (lastPage) => {
        const {current_page, last_page} = lastPage.data;
        return current_page < last_page ? current_page + 1 : undefined;
      },
    }
  );
}

export function useFetchPotentialPartnerBusinessManagers(partnerId: number, term: string = '') {
  return useInfiniteQuery(
    ['potentialPartnerBusinessManagers', partnerId, term],
    ({pageParam = 1}) => fetchPotentialPartnerBusinessManagers(partnerId, term, pageParam),
    {
      enabled: !!partnerId,
      getNextPageParam: (lastPage) => {
        const {current_page, last_page} = lastPage.data;
        return current_page < last_page ? current_page + 1 : undefined;
      },
    }
  );
}
